import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { DOCTOR, NAV_LINKS } from "../data/content";
import { useLang } from "../i18n/i18n";

export function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-[1500px] px-6 py-20 md:px-12">
        <div className="grid gap-16 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-crimson">{t.footer.care}</p>
            <h3 className="font-serif text-4xl font-light leading-tight text-white md:text-5xl">{DOCTOR.name}</h3>
            <p className="mt-4 max-w-md text-white/50">{t.footer.bio}</p>
          </div>

          <div>
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-white/40">{t.footer.navigate}</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.key}`}
                    className="group inline-flex items-center gap-1 text-white/70 transition-colors hover:text-crimson"
                  >
                    {t.nav[l.key]}
                    <ArrowUpRight className="h-3.5 w-3.5 -translate-x-1 opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-white/40">{t.footer.reach}</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={DOCTOR.phoneHref} className="group flex items-center gap-3 text-white/70 transition-colors hover:text-white">
                  <Phone className="h-4 w-4 text-crimson" />
                  {DOCTOR.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${DOCTOR.email}`} className="group flex items-center gap-3 text-white/70 transition-colors hover:text-white">
                  <Mail className="h-4 w-4 text-crimson" />
                  {DOCTOR.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-crimson" />
                {DOCTOR.city}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center">
          <p className="font-mono uppercase tracking-[0.2em]">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
